<template>
  <el-radio-group @change="handleChange" v-model="checkValue">
    <el-radio v-for="(option, index) in items" :key="index" :label="option.code">
      {{ option.name }}
    </el-radio>
  </el-radio-group>
</template>

<script>
export default {
  props: {
    query: String,
    value: String,
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      items: [],
      checkValue: this.value
    }
  },
  watch: {
    value(val) {
      this.checkValue = val
    }
  },
  created() {
    if (this.query) {
      this.queryOption(this.query)
    } else {
      this.items = this.options
    }
  },
  methods: {
    setValue(val) {
      this.checkValue = val
    },
    handleChange(val) {
      this.$emit('input', val)
    },
    queryOption(api) {
      this.$ajax.get(api, {}).then((res) => {
        this.items = res.data
      })
    }
  }
}
</script>
